export default "__VITE_ASSET__$ape6uKn__"